<template>
  <CollectionCard class="collection-card-meth-machine">
    <CollectionCardImage :image="item.image">
      <template #back>
        <div class="collection-card-utility-description">
          {{ item.description }}
        </div>
      </template>
    </CollectionCardImage>
    <CollectionCardHeader
      :name="item.name"
      :guild="item.guild"
    />

    <div
      v-if="methMachineActiveTeens <= 0"
      class="collection-card-meth-machine-alert"
      :class="{
        ['error']: !isMethMachineFirst,
        ['info']: isMethMachineFirst && methMachineActiveTeens <= 0,
      }"
    >
      <div class="collection-card-meth-machine-alert-icon">
        <IInfo width="20" />
      </div>
      <span v-if="!isMethMachineFirst">
        There is another METH Machine of the same Guild in the Your wallet.
        Hence, this METH machine will not generate any Harvestable METH tokens
      </span>
      <span v-else-if="methMachineActiveTeens <= 0">
        There are no Teens which belong to the same Guild as METH machine.
        Breed your OG Bulls or get Teens of the same guild from the secondary
        so that this METH machine can generate harvestable METH
        tokens
      </span>
    </div>
    <div class="collection-card-meth-machine-active-teens">
      Active Teens:
      <b>{{ methMachineActiveTeens }}</b>
    </div>
    <CollectionCardMethInfo
      :meth="methGenerate"
      :is-harvestable="true"
    />
  </CollectionCard>
</template>
<script>
import { computed, defineComponent } from "vue";
import CollectionCardHeader from "../CollectionCard/CollectionCardHeader.vue";
import CollectionCard from "../CollectionCard/CollectionCard.vue";
import CollectionCardImage from "../CollectionCard/CollectionCardImage.vue";
import CollectionCardMethInfo from "../CollectionCard/CollectionCardMethInfo.vue";
import { useWalletCollectionStore } from "@/store/wallet-collection";
import IInfo from "@/assets/img/info.svg?inline"
export default defineComponent({
    components: { IInfo, CollectionCardMethInfo, CollectionCardImage, CollectionCardHeader, CollectionCard },
    props: {
        item: Object,
    },
    setup(props) {
        const walletCollectionStore = useWalletCollectionStore()
        const isMethMachineFirst = computed(() => {
            const itemIdx = walletCollectionStore.methMachines.findIndex(
                (maker) => maker.guild === props.item.guild
            );
            const objIdx = walletCollectionStore.methMachines.indexOf(props.item);
            return itemIdx === objIdx;
        })
        const methMachineActiveTeens = computed(() => {
            if (!isMethMachineFirst.value) return 0;
            const items = walletCollectionStore.teens.filter(
                (teen) => teen.guild == props.item.guild && !teen.isResurrected
            );
            return items.length;
        })
        const methGenerate = computed(() => {
            return methMachineActiveTeens.value * 5
        })
        return {
            methGenerate,
            isMethMachineFirst,
            methMachineActiveTeens
        }
    }
})
</script>
<style lang="scss">
.collection-card-meth-machine {
    &-active-teens {
        text-align: left;
        font-size: 14px;
        margin-top: 5px;
        b {
            color: var(--primary);
            font-weight: bold;
        }
    }
    &-alert {
        font-size: 14px;
        padding: 5px 0;
        &-icon {
            display: flex;
            justify-content: center;
            margin-bottom: -15px;
            position: relative;
            z-index: 2;
            svg {
                background-color: var(--bg);
                padding: 5px;
            }
        }
        span {
            display: inline-block;
            padding: 8px;
            padding-top: 12px;
            border: 1px solid;
            border-radius: 5px;
        }
        &.error {
            color: #ff0000;

            span {
                border-color: rgba(255, 0, 0, 0.5);
            }
        }
        &.info {
            color: #98d8ff;

            span {
                border-color: rgba(152, 216, 255, 0.5);
            }
        }
    }
}
</style>